// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;Mercy and truth are met together,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;righteousness and peace have kissed each other;<br> </p> </div></div>";
// Exports
module.exports = code;